import type { Underlying } from 'models/underlying';
import type { UnderlyingCodeType, UnderlyingStrike } from 'models/underlying/base';
import { createContext } from 'react';

interface IUnderlyingContext {
  isLoading: boolean;
  codeTypes: UnderlyingCodeType[];
  hasRemoveAll: boolean;
  isReadOnly: boolean;
  canBeRemoved: boolean;
  onUnderlyingRemoved?: (underlyingId: string) => void;
  onUnderlyingReplaced?: (underlyingId: string, newUnderlying: Underlying) => void;
  onUnderlyingStrikeChanged?: (
    underlyingId: string,
    changeKey: keyof UnderlyingStrike,
    changeValue: Nullable<string> | Nullable<number>,
  ) => void;
  onUnderlyingWeightChanged?: (underlyingId: string, changeValue: number) => void;
  onUnderlyingCutOffChanged?: (underlyingId: string, changeValue: string) => void;
  getCellHighlight: (underlyingId: string, columnId: string) => string | undefined;

  onRemoveAll?: () => void;
  strikeModes: string[];
  hasCutOff: boolean;
}

const emptyUnderlyingContext: IUnderlyingContext = {
  codeTypes: [],
  isLoading: false,
  hasRemoveAll: false,
  isReadOnly: false,
  strikeModes: [],
  canBeRemoved: false,
  hasCutOff: false,
  getCellHighlight: () => undefined,
};

export const UnderlyingContext = createContext<IUnderlyingContext>(emptyUnderlyingContext);
